/** Post history: the last 30 explicit saves; restoring loads a revision into the draft. */
import React, { useEffect, useState } from 'react';
import { Button, Drawer, Empty, List, Modal, Spin, Tag, Typography } from 'antd';
import { useTranslation } from '../../../../shared/i18n';
import { fmtDate, toastErr } from '../common';
import { sanitizeArticle } from './articleSchema';

const NOTE = { save: 'Saved', publish: 'Published', update: 'Updated', restore: 'Restored', import: 'Imported' };

const RevisionsDrawer = ({ open, onClose, api, postId, onRestored }) => {
    const { t } = useTranslation();
    const [items, setItems] = useState(null);
    const [view, setView] = useState(null);
    useEffect(() => {
        if (!open) return;
        setItems(null);
        api.get(`/posts/${postId}/revisions`).then((d) => setItems(d?.items || [])).catch((e) => { toastErr(e); setItems([]); });
    }, [open, api, postId]);
    const show = (r) => api.get(`/posts/${postId}/revisions/${r.id}`).then(setView).catch(toastErr);
    const restore = async () => {
        try {
            const d = await api.post(`/posts/${postId}/revisions/${view.id}/restore`);
            setView(null);
            onClose();
            onRestored(d);
        } catch (e) { toastErr(e); }
    };
    return (
        <Drawer open={open} onClose={onClose} title={t('Revisions')} width={420}>
            {items === null ? <Spin /> : !items.length ? <Empty description={t('No revisions yet')} /> : (
                <List dataSource={items} renderItem={(r) => (
                    <List.Item actions={[<Button key="v" size="small" onClick={() => show(r)}>{t('View')}</Button>]}>
                        <List.Item.Meta title={fmtDate(r.created_at)} description={<><Tag>{t(NOTE[r.note] || 'Saved')}</Tag><Typography.Text type="secondary">{r.title}</Typography.Text></>} />
                    </List.Item>
                )} />
            )}
            <Modal open={!!view} width={760} onCancel={() => setView(null)} title={view?.title} okText={t('Restore')} onOk={restore} destroyOnHidden>
                {/* eslint-disable-next-line react/no-danger */}
                {view && <div style={{ maxHeight: '60vh', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: sanitizeArticle(view.body_html).html }} />}
            </Modal>
        </Drawer>
    );
};

export default RevisionsDrawer;
